import React, { useEffect, useState } from 'react'
import './Partie.css';
import LogoClub from './LogoClub';
import winnerLogo from '../assets/winner.png';

function Partie({match, status, teamJA = null, teamJB = null, numJA = null, numJB = null, isLivescoring = false, isOffDown = false}) {
    const [currentServeur, setCurrentServeur] = useState(0);
    
    useEffect(() => {
        if (isLivescoring) {
            updateService();
        }
    }, [match])

    const isMatchFinished = () => {
        return status === "termine";
    }

    const isPartieFinished = () => {
        if (isOffDown) {
            return parseInt(match.scorea) === 1 || parseInt(match.scoreb) === 1
        }
        return parseInt(match.scorea) === 3 || parseInt(match.scoreb) === 3
    }

    const isCurrentSet = (set) => {
        return set === match?.detail.length;
    }

    function updateService() {
        const firstServeur = match.premier_serveur; let serveur = "";
        const currentSet = match.detail.length;
        let endMatch = false; let prolongation = false;

        // on récupère les points des deux joueurs
        let pointJA = parseInt(match.detail[currentSet-1][0]);
        let pointJB = parseInt(match.detail[currentSet-1][1]);

        // Le serveur change à chaque nouveau set
        if (currentSet % 2 !== 0) {
            serveur = firstServeur;
        }
        else {
            serveur = firstServeur === "JA" ? "JB" : "JA";
        }

        // on regarde si c'est la fin du match
        if (pointJA >= 11 || pointJB >= 11) {
            if (pointJA >= pointJB) {
                endMatch = (pointJA - pointJB) >= 2 
            }
            else if (pointJB >= pointJA) {
                endMatch = (pointJB - pointJA) >= 2
            }
            // Si dernier SET et fin du match alors plus de serveur
            if (currentSet == 5 && endMatch) {
                setCurrentServeur(0);
                return;
            }
        } 

        // prolongation 
        if (pointJA >= 10 && pointJB >= 10 && !endMatch) {
            prolongation = true;
        }
 
        // on calcul les points totals
        let total = pointJA + pointJB;
        let count = total;
        let serveur_verification = false;

        if (!prolongation) {
            count = total / 2;
            serveur_verification = Math.floor(count) % 2 == 0
        }
        else {
            serveur_verification = Math.floor(count) % 2 !== 0
        }

        // on met à jour le serveur
        if ((serveur_verification || total === 0) && endMatch === false) { // si fin du match => prochain serveur
            setCurrentServeur(serveur === "JA" ? 1 : 2);
        }
        else {
            setCurrentServeur(serveur === "JA" ? 2 : 1);
        }
    }

    const getWinner = () => {
        if (isPartieFinished()) {
            let winner = (parseInt(match.scorea) || 0) > (parseInt(match.scoreb) || 0) ? 1 : 2;
            return winner;
        }
        return 0;
    }

    const getSetWinner = (index, pointSetA, pointSetB) => {
        if(isPartieFinished()) {
            if((index == 0 && pointSetA > pointSetB) || (index == 1 && pointSetA < pointSetB)) return true;
        }
        return false;
    }
    
    return ( 
        <div className="partie_component">
            {
                [1, 2].map((item, index) => {
                    if(Object.keys(match).length > 0)
                    {
                        return (
                            <div className="partie_player" key={index}>
                                {isLivescoring && (
                                        <div className={"service " + (currentServeur === (item) ? "active" : "")}></div>
                                    )
                                }
                                <div className="partie_logo">
                                    <LogoClub club={index == 0 ? teamJA : teamJB} activateLink={false} />
                                </div>
                                {/* On affiche le classement du joueur
                                uniquement si on a l'info
                                c'est compliqué de la récupérer en optimisant la requête donc pour l'instant je laisse comme ça */}
                                {
                                    numJA !== null && numJB !== null &&
                                    <div className="partie_player_number">
                                        <span>N°{index == 0 ? numJA : numJB}</span>
                                    </div>
                                }
                                <div className={"partie_player_name " + (getWinner() === item ? 'partie_winner' : '')}>
                                    <span>{index == 0 ? match.ja : match.jb}</span>
                                </div>
                                {/* SETS SETS SETS ET MATCHS */}
                                {
                                   match.detail.map((score, setIndex) => {
                                        return (
                                            <span 
                                                key={setIndex}
                                                className={((isLivescoring && !isPartieFinished() && isCurrentSet(setIndex+1)) ? "partie_set current" : "partie_set" ) + " " + ((getSetWinner(index, score[0], score[1])) ? "set_winner" : "")} 
                                            >
                                                {
                                                    index == 0 ? score[0] : score[1]
                                                }
                                            </span>
                                        )
                                    })
                                }
                                {/* GAGNANT DU MATCH */}
                                <img 
                                    className={'winner ' + (getWinner() === item ? 'active' : '')}
                                    src={winnerLogo} 
                                    width="28"
                                    height="28"
                                    alt="winner" 
                                />
                            </div>
                        )
                    }                  
                })
            }
        </div>
    );
}

export default Partie;